/*
 * @providesModule SKZUser
 *
 */

import _ from 'lodash';

export interface SKZUserInterface {
  id: string;
  username: string;

  flag_url: string;
  avatar_url: string;
  thumbnail_url: string;

  cash_balance: number;
  real_cash_balance: number;
  bonus_balance: number;
  z_balance: number;

  email: string;
  email_verified: boolean;
  email_opt_in: boolean;
  email_verification_required: boolean;

  can_update_username: boolean;
  identity_check_required: boolean;
  show_support_messages: boolean;
  registration_required: boolean;

  unread_support_message_count: number;

  ticketz: {
    balance: number;
    multiplier: number;
    next_multiplier: number;
    scalable_image: string;
    image: string;
    progress: number;
    goal: number;
    expires_at: string;
    ticketz_tier_id: number;
    tier_notification_type: string;
		color_code: string;
		next_ticketz_tier_id?: number;
		prev_ticketz_tier_id?: number;
  };

  leaderboards: {
    cash_rank: number;
    cash_winnings: number;

    z_rank: number;
    z_winnings: number;
  };

  chat_moderator: boolean;
  chat_registration_required: boolean;
  skillz_staff: boolean;
  new_paying_user: boolean; // Is true only for new users who deposit anywhere in Skillz and play their first cash match in said game
}

export default class User implements SKZUserInterface {
  id: string;
  username: string;

  flag_url: string;
  avatar_url: string;
  thumbnail_url: string;

  cash_balance: number;
  real_cash_balance: number;
  bonus_balance: number;
  z_balance: number;

  email: string;
  email_verified: boolean;
  email_opt_in: boolean;
  email_verification_required: boolean;

  can_update_username: boolean;
  identity_check_required: boolean;
  show_support_messages: boolean;
  registration_required: boolean;

  unread_support_message_count: number;

  ticketz: {
    balance: number;
    multiplier: number;
    next_multiplier: number;
    scalable_image: string;
    image: string;
    progress: number;
    goal: number;
    expires_at: string;
    ticketz_tier_id: number;
    tier_notification_type: string;
    color_code: string;
		next_ticketz_tier_id?: number;
		prev_ticketz_tier_id?: number;
  };

  leaderboards: {
    cash_rank: number;
    cash_winnings: number;

    z_rank: number;
    z_winnings: number;
  };

  chat_moderator: boolean;
  chat_registration_required: boolean;
  skillz_staff: boolean;
  new_paying_user: boolean;

  constructor(keyValueSource: SKZUserInterface) {
    this.id = keyValueSource.id;
    this.username = keyValueSource.username;
    this.flag_url = keyValueSource.flag_url;
    this.avatar_url = keyValueSource.avatar_url;
    this.thumbnail_url = keyValueSource.thumbnail_url;
    this.cash_balance = keyValueSource.cash_balance;
    this.real_cash_balance = keyValueSource.real_cash_balance;
    this.bonus_balance = keyValueSource.bonus_balance;
    this.z_balance = keyValueSource.z_balance;
    this.email = keyValueSource.email;
    this.email_verified = keyValueSource.email_verified;
    this.email_opt_in = keyValueSource.email_opt_in;
    this.email_verification_required = keyValueSource.email_verification_required;
    this.can_update_username = keyValueSource.can_update_username;
    this.identity_check_required = keyValueSource.identity_check_required;
    this.show_support_messages = keyValueSource.show_support_messages;
    this.registration_required = keyValueSource.registration_required;
    this.unread_support_message_count = keyValueSource.unread_support_message_count;
    this.ticketz = keyValueSource.ticketz;
    this.leaderboards = keyValueSource.leaderboards;
    this.chat_moderator = keyValueSource.chat_moderator;
    this.chat_registration_required = keyValueSource.chat_registration_required;
    this.skillz_staff = keyValueSource.skillz_staff;
    this.new_paying_user = keyValueSource.new_paying_user;
  }
}
